<template>
  <div class="indexHomeTit text-center">
    <p class="HomeTitP"><span class="indexHomeTit1"></span>{{desc}} <span class="indexHomeTit2"></span></p>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      props: [
          'desc'
      ]
        /* props: {
          desc: {
              type:Object,
              default() {
                  return {
                      'one':'qqq',
                      'two':'222'
                  }
              }

          }
        } */
    };
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/indexhometit/indexhometit.vue